import React from "react";
import classNames from "classnames";
import {
  useDownloadDocumentContent,
  useRemoveAttachedDocument,
} from "@planzone/view-models";
import { Props } from "./types";
import { Thumbnail } from "./thumbnail";
import { DownloadIcon } from "./downloadIcon";
import { RemoveIcon } from "./removeIcon";
import styles from "./styles.scss";

function DocumentCard({ document, openPreview, element, elementType }: Props) {
  const { removeAttachedDocument, isRequestPending } =
    useRemoveAttachedDocument(document.uuid);
  const {
    isRequestPending: isDownloadDocumentRequestPending,
    downloadDocumentContent,
  } = useDownloadDocumentContent(document);

  const onRemoveDocument = () => {
    if (!isRequestPending) {
      removeAttachedDocument({
        documentId: document.uuid,
        elementId: element.uuid,
        elementType,
      });
    }
  };

  return (
    <div className={styles.card} onClick={() => openPreview(document)}>
      <div className={styles.actions}>
        <div
          className={styles.actionIconBox}
          onClick={(e) => {
            e.stopPropagation();
            !isDownloadDocumentRequestPending &&
              downloadDocumentContent({ document, saveToDisk: true });
          }}
        >
          <DownloadIcon className={styles.actionIcon} />
        </div>
        <div
          className={styles.actionIconBox}
          onClick={(e) => {
            e.stopPropagation();
            onRemoveDocument();
          }}
        >
          <RemoveIcon
            className={classNames(styles.actionIcon, styles.removeIcon)}
          />
        </div>
      </div>
      <div className={styles.preview}>
        <Thumbnail
          documentId={document.uuid}
          documentUri={document.uri}
          mimeType={document.mimeType}
        />
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{document.name}</p>
        <span className={styles.date}>
          {new Date(document.createdDate).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
}

export { DocumentCard };
